
import { connect } from 'react-redux'
import { compose, branch, renderComponent, renderNothing, lifecycle } from 'recompose'
import Lesson from './Lesson'

const Component = compose(
  connect(state => {
    return {
      items: state.breadcrumb
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.dispatch({
        type: 'SET_BREADCRUMB',
        items: [
          { page: 'Aulas', url: '/#' },
        ]
      })
    }
  }),
  branch(
    () => {
      return true
    },
    renderComponent(Lesson),
    renderNothing
  )
)(Lesson)

export default Component